module.exports = __webpack_public_path__ + "static/clay-banks-68d3effe51f380d45f6473c46390f613.jpg";